<template>
	<div class="left-nav">
		<!-- 左侧导航栏 -->
		<div class="left-nav-logo">
			<img class="left-nav-logo-img" src="../assets/nav-logo.png" />
		</div>
		<div class="left-nav-list">
			<div class="left-nav-list-model" :class="{ active: item.node_id === activeId }" v-for="item in menu_list"
				:key="item.node_id" @click="selectMenu(item.node_id)">
				<img class="left-nav-list-model-img"
					:src="item.node_id === activeId ? item.active_icon_path : item.icon_path" />
				<div class="left-nav-list-model-font">{{item.display_name}}</div>
			</div>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import DailyPopup from './DailyPopup.vue';
	export default {
		name: 'LeftNav',
		components: {
			DailyPopup
		},


		data() {
			return {

				selectedSource: 0,
				indicatorLeft: 0,
				menu_list: [],
				search_source_list: [],
				activeId: null,
				searchText: '',
				more_show: false,
			};
		},
		created() {
			this.initNav()
		},

		methods: {
			selectSource(index) {
				this.selectedSource = index;
				this.$nextTick(() => {
					this.updateIndicator();
				});
			},

			initNav() {
				request.get('/businessService/v1/navigation/menuNode/fetch', {
						// params: {
						// 	article_id: id
						// }
					})
					.then(res => {
						if (res.code = '000000') {
							console.log("initNav", res)
							this.menu_list = res.menu_nodes

							this.menu_list.forEach(item => {
								this.$set(item, 'isExpanded', false);
							});
							this.activeId = res.menu_nodes[0].node_id
						}

					})
					.catch(error => {
						console.error("获取导航列表失败:", error);
					});


			},
			goDetail(id) {
				console.log("goDetail", id)
				// this.$router.push({ name: 'NavDetail', params: { id } })
				this.$router.push({
					path: `/nav/${id}`
				})


			},
			gotoLink(url) {
				this.$router.push({
					name: url
				})


			},
			selectMenu2(id) {
				this.activeId = id;
				// 页面平滑滚动到目标模块
				const target = document.getElementById(`section-${id}`);
				if (target) {
					target.scrollIntoView({
						behavior: 'smooth',
						block: 'start'
					});
				}
			},
			selectMenu(id) {
				this.activeId = id;
				this.$nextTick(() => {
					const target = document.getElementById(`section-${id}`);
					if (target) {
						const headerOffset = 60; // 假设你顶部导航高度是60px
						const elementPosition = target.getBoundingClientRect().top;
						const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

						// window.scrollTo({
						//   top: offsetPosition,
						//   behavior: 'smooth'
						// });
						this.smoothScrollTo(offsetPosition, 1000); // 700ms 可调节
					}
				});
			},


			toggleExpand(index) {
				this.menu_list[index].isExpanded = !this.menu_list[index].isExpanded;
			},

			smoothScrollTo(targetY, duration = 800) {
				const startY = window.scrollY;
				const change = targetY - startY;
				const startTime = performance.now();

				// 更丝滑的缓动函数
				const easeInOutQuad = (t) =>
					t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

				const animateScroll = (currentTime) => {
					const elapsed = currentTime - startTime;
					const progress = Math.min(elapsed / duration, 1);
					const ease = easeInOutQuad(progress);

					window.scrollTo(0, startY + change * ease);

					if (elapsed < duration) {
						requestAnimationFrame(animateScroll);
					}
				};

				requestAnimationFrame(animateScroll);
			},


		}
	};
</script>

<style>
	.left-nav {
		position: fixed;
		z-index: 999;

	}

	.left-nav-logo {
		/* Logo */

		position: absolute;
		width: 240px;
		height: 60px;
		left: 0px;
		top: 0px;
		cursor: pointer;
		/* background-color: #165DFF; */

	}

	.left-nav-logo-img {
		/* Ellipse 153 */

		position: absolute;
		width: 120px;
		height: 32px;
		left: 32px;
		top: 16px;


	}

	.left-nav-logo-font {
		/* 灵研学术 */

		position: absolute;
		width: 104px;
		height: 36px;
		left: 78px;
		top: 13px;

		font-family: 'DingTalk JinBuTi';
		font-style: italic;
		font-weight: 400;
		font-size: 26px;
		line-height: 140%;
		/* or 36px */
		display: flex;
		align-items: center;

		color: #000000;


	}

	.left-nav-list {
		/* Menu */
		height: 100vh;
		/* 填满整个视口高度 */
		/* background-color: #165DFF; */
		background: #F5F7FC;
		/* Auto layout */
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		padding: 0px;
		gap: 4px;
		/* background-color:  #165DFF; */
		position: absolute;
		width: 220px;
		/* height: 360px; */
		/* left: 10px; */
		top: 70px;
		border-right: 1px;
	}

	.left-nav-list-model {
		/* Item */

		/* Auto layout */
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 0px 24px;
		box-sizing: border-box;
		gap: 10px;

		/* width: 220px; */
		height: 48px;


		/* Inside auto layout */
		flex: none;
		order: 1;
		align-self: stretch;
		flex-grow: 0;


	}

	.left-nav-list-model:hover {
		cursor: pointer;
		/* background-color: #E8F3FF; */
		border-radius: 8px;

	}

	.left-nav-list-model.active {
		background-color: #E8F3FF;
		border-radius: 8px;

	}

	.left-nav-list-model-img {
		/* Frame */

		width: 18px;
		height: 18px;


		/* Inside auto layout */
		flex: none;
		order: 0;
		flex-grow: 0;

	}

	/* .left-nav-list-model:hover .left-nav-list-model-font {
		color: #165DFF;
	} */
	.left-nav-list-model.active .left-nav-list-model-font {
		color: #165DFF;
		font-weight: 500;
	}

	.left-nav-list-model-font {
		/* 文献检索 */

		/* width: 64px; */
		height: 22px;

		/* 16/Regular
		
		用于按钮等大多数操作类的文字
		*/
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 400;
		font-size: 16px;
		line-height: 140%;
		/* or 22px */
		display: flex;
		align-items: center;

		/* 文字/text-4 */
		color: #4E5969;


		/* Inside auto layout */
		flex: none;
		order: 1;
		flex-grow: 0;

	}
</style>